import { useCallback, useState } from 'react';
import createUseContext from 'constate';

const useProducts = () => {
  const [products, setProducts] = useState({});

  const addProducts = useCallback((key, data) => setProducts((oldProducts) => ({
    ...oldProducts,
    [key]: data,
  })), []);

  return {
    products,
    addProducts,
  };
};

const [ProductsProvider, useProductsContext] = createUseContext(useProducts);

export {
  ProductsProvider,
  useProductsContext,
};
